import API_ENDPOINTS from '../../config/api';

const getHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
};

const itCustomerService = {
    // List all IT service customers
    listCustomers: async () => {
        try {
            const response = await fetch(API_ENDPOINTS.IT_SERVICES_CUSTOMER_MANAGEMENT, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ action: 'listCustomers' })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to fetch customers');
            return data.customers || [];
        } catch (error) {
            console.error('Error fetching IT customers:', error);
            throw error;
        }
    },

    // Get customer by ID
    getCustomer: async (customerId) => {
        try {
            const response = await fetch(API_ENDPOINTS.IT_SERVICES_CUSTOMER_MANAGEMENT, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ action: 'getCustomer', customerId })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to fetch customer');
            return data.customer;
        } catch (error) {
            console.error('Error fetching IT customer:', error);
            throw error;
        }
    },

    // Sync quote to customer (manually trigger)
    syncQuote: async (quoteId) => {
        try {
            const response = await fetch(API_ENDPOINTS.IT_SERVICES_CUSTOMER_MANAGEMENT, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ action: 'syncQuote', quoteId })
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'Failed to sync quote');
            return data;
        } catch (error) {
            console.error('Error syncing quote:', error);
            throw error;
        }
    }
};

export default itCustomerService;
